import React from "react";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import styles from "./attendance-date-changer.module.css";

const AttendanceDateChanger = ({ date, onChange, isNextDateDisabled = false }) => {
  const today = new Date();
  const selectedDate = new Date(date);
  today.setHours(0, 0, 0, 0);
  selectedDate.setHours(0, 0, 0, 0);

  const shouldDisableNext = isNextDateDisabled && selectedDate >= today;

  return (
    <div className={styles["date-changer-container"]}>
      <div onClick={onChange.bind(null, -1)} className={styles["date-changer-arrow-bg"]}>
        <LeftOutlined />
      </div>

      <div className={styles["date-changer-date"]}>{date}</div>

      <div
        onClick={!shouldDisableNext ? onChange.bind(null, 1) : undefined}
        className={`${styles["date-changer-arrow-bg"]} ${
          shouldDisableNext ? styles["disabled"] : ""
        }`}
      >
        <RightOutlined />
      </div>
    </div>
  );
};

export default AttendanceDateChanger;
